export enum ModalName {
	LOGIN = 'login',
	REGISTER = 'register',
	FORGOT_PASSWORD = 'forgotPassword',
	SUCCESS = 'success',
	PROFILE = 'profile',
	HELP = 'help',
	OFFER_RULES = 'offerRules',
	OFFER = 'offer',
	BONUS = 'bonus',
	TRADE_LINK_HELP = 'tradeLinkHelp',
	CONFIRM = 'confirm',
	MORE_DETAILS = 'moreDetails',
	ITEM_DETAILS = 'itemDetails',
	TWO_FA = 'twoFa',
	PROMOTION_ENTER = 'promotionEnter',
	PROMOTION_WINNER = 'promotionWinner',
	PROMOTION_PARTICIPANTS = 'promotionParticipants',
	PROMOTION_TICKETS = 'promotionTickets',
	TOURNAMENT = 'tournament',
	QUEST_DETAILS = 'questDetails',
	PROMOTION_WINNERS_LIST = 'promotionWinnersList',
	SHOP_ITEM = 'shopItem',
	JACKPOT_INFO = 'jackpotInfo',
	JOIN_RACE_CONFIRM = 'joinRaceConfirm',
	COIN_RACE_RULES = 'coinRaceRules'
	// Add more modal types here
}

export interface ModalProps {
	isOpen: boolean;
	onClose: () => void;
	children: React.ReactNode;
}

export interface BaseModalProps {
	onSuccess?: () => void;
	onError?: (error: Error) => void;
}
